import { useEffect } from 'react';
import { initializeToken } from '../Api/Api';
import { isTokenInitialized, setInitialized } from '../../util/tokenManager';

const AppInitializer = ({ children }) => {
  useEffect(() => {
    const quickInitialize = async () => {
      // Only try to initialize if not already done
      if (!isTokenInitialized()) {
        try {
          // Quick attempt to refresh token
          await initializeToken();
        } catch (error) {
          // Silently handle initialization failure - this is expected when not logged in
          setInitialized(true);
        }
      }
    };

    quickInitialize();
  }, []);

  // Always render children immediately - never block
  return children;
};

export default AppInitializer;
